<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 96 960 960"
    width="24"
    fill="currentColor"
  >
    <path
      d="m426 888-69-63q-106-97-191.5-192.5T80 422q0-94 63-157t157-63q53 0 100 22.5t80 61.5q33-39 80-61.5T660 202q94 0 157 63t63 157q0 115-85 211T602 826l-68 62q-23 22-54 22t-54-22Zm16-522q-29-41-62-62.5T300 282q-60 0-100 40t-40 100q0 52 37 110.5T285.5 646q51.5 55 106 103t88.5 79q34-31 88.5-79t106-103Q726 591 763 532.5T800 422q0-60-40-100t-100-40q-47 0-80 21.5T518 366q-7 10-17 15t-21 5q-11 0-21-5t-17-15Zm38 189Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'FavoriteBorder'
  }
</script>
